// Settings values from the builder can be a plain string or a structured object
// (image: {src,alt}, link: {url,label}). These normalise both shapes.
export function imgSrc(v: unknown): string {
  if (!v) return ""
  if (typeof v === "string") return v
  if (typeof v === "object" && v && "src" in v) return String((v as { src: unknown }).src ?? "")
  return ""
}

export function linkUrl(v: unknown): string {
  if (!v) return ""
  if (typeof v === "string") return v
  if (typeof v === "object" && v && "url" in v) return String((v as { url: unknown }).url ?? "")
  return ""
}
